<template>
  <element>
    <nav-breadcrumb :menu="[{label: '抵押申请'}, {label: '审核'}]"/>
    <el-row>
      <el-steps class="step-shenpi">
        <el-step :title="'提交申请'" :description = "$moment(customerDetail.m__createdDate).format('YYYY-MM-DD HH:mm:ss')">
          <i class="step-start" slot="icon"></i>
        </el-step>
        <el-step v-if="approvalMortgageListcount>0" :title="'抵押审核 '+approvalMortgageList[0].a__approverName" :description="$moment(approvalMortgageList[0].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalMortgageList[0].a__approvingStatus)" >
          <i class="step-mid" slot="icon"></i>
        </el-step>
        <div class="el-step is-end" v-if="approvalMortgageListcount==0&&customerDetail.m__applicationStatus == 'Pending Approval'">
          <i class="step-over" slot="icon"></i>
          <p class="text1">抵押审核</p>
          <p class="text2">待审核</p>
        </div>
        <div class="el-step is-end" v-if="approvalMortgageListcount==1&&customerDetail.m__applicationStatus == 'Pending Approval'">
          <i class="step-over" slot="icon"></i>
          <p class="text1">风控审核</p>
          <p class="text2">待审核</p>
        </div>
      </el-steps>
      <el-col class="grid-content bg-purple">
        <el-tabs v-model="tabName">
          <template v-if="creditForm.a__approvingStatus == 'Rejected'">
            <el-tab-pane label="客户信息" name="CustomerSummary">
              <template v-if="creditForm.a__approvingStatus =='Rejected'">
                <customer-detail-component v-model="customerDetail" :is-show-pic1="true"/>
              </template>
            </el-tab-pane>
            <el-tab-pane label="抵押车辆" name="vehiclesDetail">
              <customer-detail-vehicles-component v-model="customerDetail.vehicles" :is-show-pic1="true"/>
            </el-tab-pane>
            <el-tab-pane label="担保信息" name="guarantor" class="bg-purple">
              <customer-detail-guarantor-component v-model="customerDetail"/>
            </el-tab-pane>
            <el-tab-pane label="挂靠公司" name="ext-company" class="bg-purple">
              <customer-detail-ext-company-component v-model="customerDetail" />
            </el-tab-pane>
            <el-tab-pane label="授信审批"  name="credit" class="bg-purple">
              <el-steps :active="6" class="step-shenpi">
                <el-step :title="'提交授信  '"  :description="$moment(customerDetail.ac__createdDate).format('YYYY-MM-DD HH:mm:ss')">
                  <i class="step-start" slot="icon"></i>
                </el-step>
                <el-step v-if="approvalListcount>0" :title="Status2CN(approvalList[0].a__approvalType)+approvalList[0].a__approverName" :description="$moment(approvalList[0].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[0].a__approvingStatus)" >
                  <i class="step-mid" slot="icon"></i>
                </el-step>

                <el-step v-if="approvalListcount>1" class="step-spec" :title="Status2CN(approvalList[1].a__approvalType)+approvalList[1].a__approverName"  :description="$moment(approvalList[1].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[1].a__approvingStatus)" >
                  <i class="step-mid" slot="icon"></i>
                </el-step>
                <el-step v-if="approvalListcount>2" class="step-spec" :title="Status2CN(approvalList[2].a__approvalType)+approvalList[2].a__approverName"  :description="$moment(approvalList[2].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[2].a__approvingStatus)" >
                  <i class="step-mid" slot="icon"></i>
                </el-step>
                <el-step v-if="approvalListcount>3" class="step-spec" :title="Status2CN(approvalList[3].a__approvalType)+approvalList[3].a__approverName"  :description="$moment(approvalList[3].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[3].a__approvingStatus)" >
                  <i class="step-mid" slot="icon"></i>
                </el-step>
                <el-step v-if="approvalListcount>4" class="step-spec" :title="Status2CN(approvalList[4].a__approvalType)+approvalList[4].a__approverName"  :description="$moment(approvalList[4].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[4].a__approvingStatus)" >
                  <i class="step-mid" slot="icon"></i>
                </el-step>
                <el-step :title="'完成'" v-if="customerDetail.ac__applicationStatus == 'Approved'" >
                  <i class="step-over" slot="icon"></i>
                </el-step>
              </el-steps>

              <panel>
                <data-table
                  :table-data="approvalArry"
                  :columns="tableColumns"
                  :is-pagination-show="false"
                />
              </panel>
              <template>
                <div>
                  <el-form label-width="150px">
                    <el-row>
                      <panel title="授信信息" border>
                        <el-col :span="24">
                          <el-form-item label="贷款产品：">
                            {{customerDetail.p__productName}}
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="授信类型：">
                            {{customerDetail.cr__creditType}}
                          </el-form-item>
                          <el-form-item label="授信起始日：">
                            {{customerDetail.cr__creditValidity1}}
                          </el-form-item>
                          <el-form-item label="贷款比例：">
                            {{customerDetail.cr__financingRatio}} %
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="授信额度：">
                            {{customerDetail.cr__lineOfCredit}}
                          </el-form-item>
                          <el-form-item label="授信到期日：">
                            {{customerDetail.cr__creditValidity2}}
                          </el-form-item>
                          <el-form-item label="贷款阈值：">
                            {{customerDetail.cr__threshold|formatMoney}} 元
                          </el-form-item>
                        </el-col>
                      </panel>
                    </el-row>
                  </el-form>
                </div>
              </template>
              <panel title="附件列表">
                <files-data-table :files.sync="files.files"></files-data-table>
              </panel>
              <panel title="抵押审核">
                <data-table
                  :table-data="approvalMortgageArry"
                  :columns="tableColumns"
                  :is-pagination-show="false"
                />
              </panel>
            </el-tab-pane>
            <form-build
              form-name="approveForm"
              :form-data.sync="approvalForm"
              :form-rules="approvalFormRules"
              :form-columns-group="approvalFormColumnsGroups"
              :form-buttons="approvalFormButtons"
            />
          </template>
         <!-- <el-tab-pane label="授信详情" name="creditDetail" v-if="creditForm.a__approvingStatus == 'Approved'">
            <template v-if="creditForm.a__approvingStatus == 'Approved'">
              <form-build
                form-name="creditForm"
                :form-data.sync="creditForm"
                :form-columns-group="creditFormColumnsGroup"
                :form-rules="creditFormRules"
                :form-buttons="creditFormButtons"
                label-width="170px"
                ref="FormBuild"
              />
              <el-row>
                <el-col :span="24">
                  <files-upload :file-list.sync="fileList"></files-upload>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-button type="primary" @click="onSubmit('creditForm')">确认提交</el-button>
                  <el-button @click="$router.back()">取消</el-button>
                </el-col>
              </el-row>
            </template>
          </el-tab-pane>-->
        </el-tabs>
      </el-col>
    </el-row>
  </element>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import creditTypeOptions from '../../../utils/creditTypeOptions'
  import CustomerDetailComponent from '../../components/CustomerDetailComponent'
  import CustomerDetailVehiclesComponent from "../../components/CustomerDetailVehiclesComponent";
  import CustomerDetailGuarantorComponent from "../../components/CustomerDetailGuarantorComponent";
  import CustomerDetailExtCompanyComponent from "../../components/CustomerDetailExtCompanyComponent";
  import Status2CN from "../../../filters/Status2CN";
  import moment from 'moment'
  export default {
    name: "ApplicationProcess",
    data() {
      return {
        tabName: 'CustomerSummary',
        creditId: this.$route.query['cr.creditId']||'',
        customerDetail: {
          vehicles: []
        },
        approvalArry:{
          data:[],
          count:0,
        },
        approvalMortgageArry:{
          data:[],
          count:0,
        },
        tableColumns: [
          {
            label: '节点',
            field: 'node',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },
          {
            label: '操作人',
            field: 'approverName'
          },
          {
            label: '操作时间',
            field: 'time',
            formatter: function (r,c,v) {
              return v ? moment(v).format('YYYY-MM-DD HH:mm:ss') : ''
            }
          },
          {
            label: '操作结果',
            field: 'status'
          }, {
            label: '操作备注',
            field: 'remarks'
          },

        ],
        files:{},
        debtorList:{},
        productList: {},
        approvalList:{},
        approvalListcount:0,
        approvalMortgageList:{},
        approvalMortgageListcount:0,
        creditTypeOptions: creditTypeOptions,
        approvalForm: {
          "a__approvingStatus": "Rejected",
          "a__remarks": ""
        },
        approvalFormRules: {

        },
        approvalFormColumnsGroups: [
          {
            label: '审核结果',
            columns: [
              {
                label: '审核意见',
                component: 'el-input',
                type: 'textarea',
                field: 'a__remarks',
                span: 24
              }
            ]
          }
        ],
        approvalFormButtons: [
          {
            label: '审核通过',
            type: 'primary',
            clickHandler: ($refs)=>{
              $refs.validate(valid=>{
                if(valid) {
                  this.creditForm.a__approvingStatus = 'Approved'
                  this.creditForm.a__remarks = this.approvalForm.a__remarks
                  this.updateApproveVehicleMortgageCustomer()
                }
              })
            }
          },
          {
            label: '否决',
            clickHandler: ($refs)=>{
              this.creditForm.a__approvingStatus = 'Rejected'
              this.creditForm.a__remarks = this.approvalForm.a__remarks

              this.updateApproveVehicleMortgageCustomer()
            }
          }
        ],
        creditForm: {
          "m__applicationId" : this.$route.query['m.applicationId'],
          "a__approvingStatus": 'Rejected',
          "a__remarks": "",
          "cr__checked": true,
          "cr__creditId": this.$route.query['cr.creditId']||'',
          "cr__creditType": "",
          "cr__creditValidity": [],
          "cr__creditValidity1": "",
          "cr__creditValidity2": "",
          "cr__customerId": "",
          "cr__debtorId": "",
          "cr__financingRatio": "",
          "cr__lineOfCredit": 0,
          "cr__productId": "",
          "cr__threshold": "",
          files: []
        },
        creditFormRules: {
          cr__creditType: [
            {
              required: true,
              message: '授信类型不能为空！'
            }
          ],
          cr__creditValidity: [
            {
              required: true,
              message: '授信起始、截止日期不能为空！'
            }
          ],
          cr__debtorId: [
            {
              required: true,
              message: '供应链不能为空！'
            }
          ],
          cr__financingRatio: [
            {
              required: true,
              message: '贷款比例不能为空！'
            }
          ],
          cr__lineOfCredit: [
            {
              required: true,
              message: '授信额度不能为空！'
            }
          ],
          cr__productId: [
            {
              required: true,
              message: '贷款产品不能为空！'
            }
          ],
          cr__threshold: [
            {
              required: true,
              message: '贷款阈值不能为空！'
            }
          ]
        },
        creditFormButtons: [

        ]
      }
    },
    components: {
      CustomerDetailExtCompanyComponent,
      CustomerDetailGuarantorComponent,
      CustomerDetailComponent,
      CustomerDetailVehiclesComponent
    },
    computed: {
      m__applicationId() {
        return this.$route.query['m.applicationId']
      },
      creditFormColumnsGroup() {
        return [
          {
            label: '授信详情',
            columns: [
              // {
              //   label: '客户名称',
              //   field: 'cr__customerId',
              //   component: 'el-select',
              //   filterable: true,
              //   options: this.customerList
              // },
              {
                label: '供应链',
                field: 'cr__debtorId',
                filterable: true,
                component: 'el-select',
                options: this.debtorList
              },
              {
                label: '贷款产品',
                field: 'cr__productId',
                filterable: true,
                component: 'el-select',
                options: this.productList
              },
              {
                label: '授信类型',
                field: 'cr__creditType',
                filterable: true,
                component: 'el-select',
                options: creditTypeOptions
              },
              {
                label: '核准授信额度',
                field: 'cr__lineOfCredit',
                component: 'el-input',
                unit: '元'
              },
              {
                label: '授信起始-到期日',
                field: 'cr__creditValidity',
                component: 'date-range-picker',
              },
              {
                label: '贷款比例',
                field: 'cr__financingRatio',
                component: 'el-input',
                unit: '%'
              },
              {
                label: '贷款阈值',
                field: 'cr__threshold',
                component: 'el-input',
                unit: '元'
              },
            ]
          },
        ]
      },
      fileList: {
        get() {
          return this.creditForm.files
        },
        set(newVal) {
          this.creditForm.files = newVal.map(item => Object.assign(item, {
              'ca__fileId': item.fileId,
              'ca__checked': true
            })
          )
        }
      }
    },
    mounted() {
      if( this.creditId ) {
        this.getCustomerCreditDetail(this.creditId)
      }
      this.getApplyingVehicleMortgageCustomerDetail()
      this.getDebtorList()
      this.getFinanceProductList()
    },
    methods: {
      Status2CN,
      setMortgageApproval:function(){
        let count =1
        this.approvalMortgageArry.data.push(
          {
            node:'提交申请',
            approverName:'System',
            time:this.customerDetail.cr__createdDate,
            status:'提交成功',
            remarks:'',

          }
        )

        for(var i=0;i<this.approvalMortgageList.length;i++){
          let name =this.approvalMortgageList[i].a__approvalType


          this.approvalMortgageArry.data.push(
            {
              node:name,
              approverName:this.approvalMortgageList[i].a__approverName,
              time:this.approvalMortgageList[i].a__approvingDate,
              status:Status2CN(this.approvalMortgageList[i].a__approvingStatus),
              remarks:this.approvalMortgageList[i].a__remarks,

            }
          )
          count++


        }
        this.approvalMortgageArry.count = count
        console.log(this.approvalArry)
      },
      setApproval:function(){
        let arr=[]
        let count =2
        this.approvalArry.data.push(
          {
            node:'提交授信',
            approverName:'System',
            time:this.customerDetail.cr__createdDate,
            status:'提交成功',
            remarks:'',

          }
        )

        for(var i=0;i<this.approvalList.length;i++){
          let name =this.approvalList[i].a__approvalType


          this.approvalArry.data.push(
            {
              node:name,
              approverName:this.approvalList[i].a__approverName,
              time:this.approvalList[i].a__approvingDate,
              status:Status2CN(this.approvalList[i].a__approvingStatus),
              remarks:this.approvalList[i].a__remarks,

            }
          )
          count++


        }
        this.approvalArry.count = count
        console.log(this.approvalArry)
      },
      getApplyingVehicleMortgageCustomerDetail: function () {
        xhr.getApplyingVehicleMortgageCustomerDetail({
          'm.applicationId': this.$route.query['m.applicationId']
        }, res=>{
          try{
            if(res.data.status == 'success') {
              this.customerDetail = res.data.data
              this.customerDetail.vehicles = this.customerDetail.vehicles.filter(item=>item.vehicle__vehicleId)
              this.getApplyingCustomerCreditAttachment(this.customerDetail.ac__applicationId)
              this.getCustomerApprovalList(this.customerDetail.ac__applicationId)
              this.getMortgageApprovalList(this.$route.query['m.applicationId'])

            }
          }catch(e){}
        })
      },
      getApplyingCustomerCreditAttachment:function(applicationId){
        xhr.getApplyingCustomerCreditAttachment({
          'c.applicationId': applicationId
        }, res=>{
          try{
            if(res.data.status == 'success') {
              this.files = res.data.data
            }
          }catch(e){}
        })
      },
      getMortgageApprovalList: function(applicationId) {
        xhr.getCustomerApprovalList(
          {
            'a.applicationId': applicationId,
            pageSize: 100
          },
          res=>{
            try {
              if(res.data.status == 'success') {
                this.approvalMortgageList = res.data.data
                this.approvalMortgageListcount = res.data.count
                console.log( res.data.count)

                  this.setMortgageApproval()
              }
            }catch (e) {

            }
          }
        )
      },
      getCustomerApprovalList: function(applicationId) {
        xhr.getCustomerApprovalList(
          {
            'a.applicationId': applicationId,
            pageSize: 100
          },
          res=>{
            try {
              if(res.data.status == 'success') {
                this.approvalList = res.data.data
                this.approvalListcount = res.data.count
                this.setApproval()
              }
            }catch (e) {

            }
          }
        )
      },

      getCustomerCreditDetail: function (creditId) {
        xhr.getCustomerCreditDetail({
            'cr.creditId': creditId
          },
          res=> {
            try{
              if(res.data.status == 'success') {
                res.data.data.cr__creditValidity = [
                  res.data.data.cr__creditValidity1,
                  res.data.data.cr__creditValidity2
                ]
                this.creditForm = res.data.data
              }
            }catch (e) {

            }
          })
      },
      getDebtorList: function () {
        xhr.getDebtorList({
          pageSize: 1000
        },res=>{
          try{
            if(res.data.status == 'success') {
              this.debtorList = res.data.data.map(item=>{
                return {
                  label: item.c__customerName,
                  value: item.c__customerId
                }
              })
              if(this.debtorList.length == 1) {
                this.creditForm.cr__debtorId = this.debtorList[0].value
              }
            }
          }catch (e) {

          }
        })
      },
      getFinanceProductList: function () {
        xhr.getFinanceProductList(
          {
            pageSize: 1000
          },
          res=>{
            try{
              if(res.data.status == 'success') {
                this.productList = res.data.data.map(item=>{
                  return {
                    label: item.p__productName,
                    value: item.p__productId
                  }
                })
                if(this.productList.length == 1) {
                  this.creditForm.cr__productId = this.productList[0].value
                }
              }
            }catch (e) {

            }
          }
        )
      },
      onSubmit: function (formName) {
        this.$refs.FormBuild.$refs[formName].validate((valid)=>{
          if(valid) {
            [this.creditForm.cr__creditValidity1, this.creditForm.cr__creditValidity2] = this.creditForm.cr__creditValidity

            this.updateApproveVehicleMortgageCustomer()
          }
        })
      },
      updateApproveVehicleMortgageCustomer: function () {

        xhr.updateApproveVehicleMortgageCustomer(
          this.creditForm,
          res=> {
            try{
              if(res.data.status == 'success') {

              }
              this.$router.push({
                path: 'List'
              })
            }catch (e) {

            }
          }
        )
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/CustomerAdmin/CustomerApplyingVehicleMortgageApprove.vue